import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddUserToWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackAddUserToWishList = (
    parameters: TrackAddUserToWishListParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "add_user_to_wishlist", ...parameters }, options);
};

export default trackAddUserToWishList;
